import * as types from './types'
import EstateResource from '../../resources/Estate'

export const actions = {
	storePatrimonial ({ commit }, request) {
		console.log('data', request);
		const data = request.data
		commit(types[request.name], { data })
		if (!request.fromStart) {
			commit('VALIDATION', request.name)
		}
	},
	savePatrimonial ({ commit, dispatch, state }, request) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit(types.SET_ID, { data: { id: request } })
			EstateResource.savePatrimonial(dispatch, state, request).then((response) => {
				commit('FILL_ESTATE')
				commit('LOADER_OUT')
				resolve(response)
			}).catch((e) => {
				commit('LOADER_OUT')
				reject(e)
			})
		})
	},
	getPatrimonial ({ state, dispatch, commit }, id = null) {
		commit(types.CLEAR)
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			EstateResource.getPatrimonial(dispatch, state, id).then(() => {
				commit('LOADER_OUT')
				resolve()
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/store/PatrimonialEstate/actions.js